import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  loading: null,
  error: false,
  loaded: null,
  data: null,
  newsList: [],
};

// Slice
const storeNewsSlice = createSlice({
  name: "storeNews",
  initialState,
  reducers: {
    findNews() {},
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setNews(state, action) {
      const { newsList } = action.payload;
      return {
        ...state,
        newsList,
      };
    },
  },
});

export const { findNews, fetchDataSuccess, fetchDataFailure, setNews } =
  storeNewsSlice.actions;

export default storeNewsSlice.reducer;

function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });

    const response = yield call(apiService.get, apiUrl);
    yield put(fetchDataSuccess(response.data));

    if (response?.data) {
      const { code, data } = response.data;
      if (code === "0000") {
        yield put(setNews({ newsList: data }));
      } else {
        yield put(setNews({ newsList: [] }));
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
    yield put(setNews({ newsList: [] }));
  }
}

// API 호출을 감시하는 Saga 함수
export function* storeNewsSaga() {
  yield takeLatest(findNews.type, fetchDataSaga);
}
